// Field config untuk AppCardList (tampilan mobile).
// `variant` menentukan bentuk baris:
//   - 'primary' : label kecil + nilai besar (dipakai untuk nilai utama)
//   - 'row'     : label kiri, nilai kanan (default)
//   - 'grid'    : dua kolom; field grid yang berurutan digabung satu baris
//   - 'footer'  : baris penutup dengan garis atas
export const cardProjectList = [
  {
    key: "value",
    label: "Project Value",
    variant: "primary",
    type: "currency"
  },
  {
    key: "tax_value",
    label: "Tax and other fees",
    variant: "inline",
    type: "currency"
  },
  {
    key: "start_date",
    label: "Start Date",
    variant: "inline",
    type: "date"
  },
  {
    key: "end_date",
    label: "End Date",
    variant: "inline",
    type: "date"
  },
  {
    key: "createdAt",
    label: "Date Added",
    variant: "footer",
    type: "date"
  },
]

// letter_number & letter_type sudah tampil sebagai title/subtitle card,
// jadi tidak diulang di daftar field.
export const cardLetterNumberList = [
  {
    key: "letter_recipient",
    label: "Recipient",
    variant: "inline"
  },
  {
    key: "letter_notes",
    label: "Notes",
    variant: "stacked"
  },
  {
    key: "createdAt",
    label: "Date",
    variant: "footer",
    type: "date"
  },
]

export const cardInvoiceList = [
  {
    key: "value",
    label: "Invoice Value",
    variant: "primary",
    type: "currency"
  },
  {
    key: "status_invoice",
    label: "Status",
    variant: "grid",
    type: "badge",
    badgeColors: {
      Draft: 'secondary',
      Published: 'success'
    }
  },
  {
    key: "invoice_payment",
    label: "Payment",
    variant: "grid",
    type: "badge",
    badgeColors: {
      'Not Paid': 'secondary',
      Paid: 'success'
    }
  },
  {
    key: "createdAt",
    label: "Created Date",
    variant: "footer",
    type: "date"
  },
]
